import {AuditsApi} from "@/Stub/V1";
import { BaseApiConfig } from "@/Service/Api/V1/BaseApiConfig";


export const AuditsApiClient = new AuditsApi(BaseApiConfig);